(function($) {
	$('.clock').each(function(i, e) {
		$(e).countdown($(e).data('expare'), function(event) {
		  var $this = $(this).html(event.strftime('' +
			'<div class="row time-row mx-n5 px-10">' + 
			'<div class="col px-5">' + 
			'<div class="clock__digit">%D</div>' + 
			'<span class="clock__abr text-uppercase d-inline-block pt-15">days</span>' + 
			'</div>' + 
			'<div class="col px-5">' + 
			'<div class="clock__digit">%H</div>' + 
			'<span class="clock__abr text-uppercase d-inline-block pt-15">hrs</span>' + 
			'</div>' + 
			'<div class="col px-5">' + 
			'<div class="clock__digit">%M</div>' + 
			'<span class="clock__abr text-uppercase d-inline-block pt-15">min</span>' + 
			'</div>' + 
			'<div class="col px-5">' + 
			'<div class="clock__digit text-red">%S</div>' + 
			'<span class="clock__abr text-uppercase d-inline-block pt-15">sec</span>' + 
			'</div>' + 
			'</div>'));
		});
	});
})(jQuery);